<div class="overlay" id="overlay" (click)="closeOnOverlay ? onCancel() : null">
  <dialog class="dialog" [open]="isOpen">
    <header>
      <h2>{{ title }}</h2>
    </header>

    <section class="content">
      <ng-content></ng-content>
    </section>
    @if (showCancel || showConfirm) {
      <footer>
        @if (showConfirm) {
          <app-button
            [label]="confirmText"
            type="button"
            (click)="onConfirm()"
            variant="primary"
            class="button"
          ></app-button>
        }
        @if (showCancel) {
          <app-button
            [label]="cancelText"
            type="button"
            (click)="onCancel()"
            variant="secondary"
            class="button"
          ></app-button>
        }
      </footer>
    }
  </dialog>
</div>
